import { LandingTheme, TemplateNames } from '@anm/api/modules/hosting';

type ThemeItem = {
  name: LandingTheme;
};

type LayoutItem = {
  name: TemplateNames;
  iconSrc: string;
};

const srcPrefix = `images/video-landings/icons`;

export const layoutSelection: LayoutItem[] = [
  {
    name: 't1',
    iconSrc: `${srcPrefix}/layout/layout1.svg`
  },
  {
    name: 't2',
    iconSrc: `${srcPrefix}/layout/layout2.svg`
  },
  {
    name: 't3',
    iconSrc: `${srcPrefix}/layout/layout3.svg`
  },
  {
    name: 't4',
    iconSrc: `${srcPrefix}/layout/layout4.svg`
  },
  {
    name: 't5',
    iconSrc: `${srcPrefix}/layout/layout5.svg`
  }
];

export const themeSelection: ThemeItem[] = [
  {
    name: 'pure'
  },
  {
    name: 'dawn'
  },
  {
    name: 'pale'
  },
  {
    name: 'dusk'
  },
  {
    name: 'deep'
  },
  {
    name: 'lily'
  },
  {
    name: 'mist'
  },
  {
    name: 'sand'
  },
  {
    name: 'dew'
  },
  {
    name: 'peony'
  },
  {
    name: 'night'
  },
  {
    name: 'daisy'
  }
];
